import { createFileRoute } from '@tanstack/react-router';

import { HStack, VStack } from '@/components/Layout';
import NavigationCard, {
  type NavigationSectionGroup,
} from '@/components/Navigation/NavigationCard';
import { defaultNS, useTranslation } from '@/lib/i18n';

import { ApplicantContactsSection } from './-components/ApplicantContactsSection';

export const Route = createFileRoute('/_staff/labor-core/_packages/settings/')({
  component: SettingsPage,
});

function SettingsPage() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'pages.laborCore.settings',
  });

  const navigationSections: NavigationSectionGroup[] = [
    {
      titleLabel: '',
      to: '/labor-core/settings',
      sections: [
        {
          label: t('applicantContacts.title'),
          hash: 'applicant-contacts',
        },
      ],
    },
  ];

  return (
    <HStack className="p-8 gap-8">
      <nav className="sticky top-8 h-fit w-60">
        <NavigationCard sections={navigationSections} />
      </nav>
      <VStack className="w-full gap-12">
        <div id="applicant-contacts">
          <ApplicantContactsSection />
        </div>
      </VStack>
    </HStack>
  );
}
